import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Logger, toastActions } from "@base-provider";
import GridExample from "./grid-example";
import QueryBuilder from "./queryBuilder";
import {
  SFButton,
  SFIconButton,
  SFAddIcon,
  SFDashboardIcon,
  SFMoreHorizontalIcon,
  SFBadge,
  SFCard,
  SFTab,
  SFTabs,
  SFTabbedCard,
  SFCardTab,
  SFAccordion,
  SFAccordionSummary,
  SFAccordionDetails,
  SFLineChart,
  SFTypeahead,
  SFSkeleton,
  SFCheckbox,
  SFDivider,
  SFGridContainer,
  SFGridItem,
  SFDropdown,
  SFStack,
  SFContainer,
  getTypeaheadResults,
  SFTextEditor,
  SFAccordionCard,
} from "@sf-core";
import Typography from "@mui/material/Typography";
import IncludeCheckbox from "./includeCheckbox";
//import Motif from "./motif.js";
import Insights from "./tabbedCardMock/insights";
import ProficiencyLevel from "./tabbedCardMock/profLevel";
//import { cardImage } from "@ey-xd/motif-react/assets/images";
import Stepper from "./stepper";
import RadioGroupExample from "./radioGroup";
import ButtonGroup, { SortButtonGroup } from "./buttonGroup";
import PillStepper from "./pillStepper";

const lineChartData = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Page G",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

const lineChartLines = [
  {
    type: "monotone",
    dataKey: "pv",
    stroke: "#8884d8",
    activeDot: { r: 8 },
  },
  {
    type: "monotone",
    dataKey: "uv",
    stroke: "#82ca9d",
  },
];

const Mock = () => {
  const dispatch = useDispatch();
  //const [isOpen, setIsOpen] = useState(false);
  const [accordionOpen, setAccordionOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const onClickTabHandler = (event, newValue) => {
    setActiveTab(newValue);
  };
  const accordionChangeHandler = (panel) => (event, isExpanded) => {
    setAccordionOpen(isExpanded ? panel : false);
  };

  // const dropdownToggleHandler = () => {
  //   setIsOpen((prevState) => !prevState);
  // };
  const cardHeader = (
    <React.Fragment>
      <div>
        <span className="motif-h6">
          Long card header title rendered in two lines
        </span>
        <SFIconButton type="button">
          <SFMoreHorizontalIcon />
        </SFIconButton>
      </div>
    </React.Fragment>
  );
  const cardBody = (
    <React.Fragment>
      <div>
        <p className="motif-body" style={{ maxWidth: 250, margin: 0 }}>
          Touted as the “new electricity”, AI is expected to transform every
          industry – spawning new products and services, unlocking new
          efficiencies, creating new business models, driving new profit pools
          and delivering significant financial and human value.
        </p>
      </div>
    </React.Fragment>
  );
  const cardImageSection = (
    <div>
      <img
        src="data:image/gif;base64,R0lGODdhAQABAPAAAP8AAAAAACwAAAAAAQABAAACAkQBADs"
        alt="woman on glacier with EY in the center"
      />
    </div>
  );

  const selectSearchOptionHandler = (value) => {
    Logger.of("App.mock.typeaheadSelectHandler").info({
      value: value,
    });
  };

  return (
    <SFContainer>
      <SFGridContainer>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5" sx={{ my: 2 }}>
           Query Builder
          </Typography>
          <QueryBuilder />
        </SFGridItem>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5" sx={{ my: 2 }}>
            Pill Stepper
          </Typography>
          <PillStepper />
        </SFGridItem>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5" sx={{ my: 2 }}>
            Text editor
          </Typography>
          <SFTextEditor
            label="Label"
            onChange={(value) =>
              Logger.of("App.mock.textEditor").info({
                value: value,
              })
            }
          />
        </SFGridItem>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5" sx={{ my: 2 }}>
            Radio group
          </Typography>
          <RadioGroupExample />
        </SFGridItem>
      </SFGridContainer>
      <SFGridContainer>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5" sx={{ my: 2 }}>
            Accordion card
          </Typography>
          <SFAccordionCard title="Accordion card title">
            Accordion card content
          </SFAccordionCard>
        </SFGridItem>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5" sx={{ my: 2 }}>
            Stepper
          </Typography>
          <Stepper />
        </SFGridItem>
      </SFGridContainer>
      <div className="motif-row" style={{ paddingBottom: 30 }}>
        <div className="motif-col-xs-4">
          <div className="motif-h4">Reusable components across app</div>
        </div>
      </div>
      <div className="motif-row" style={{ paddingBottom: 25 }}>
        <div className="motif-col-xs-4" style={{ paddingBottom: 15 }}>
          <hr />
          <div className="motif-h5">Typeahead</div>
        </div>
        <div className="motif-col-xs-4">
          <SFTypeahead
            disablePortal={true}
            fetchData={(param) =>
              getTypeaheadResults("http://localhost:5001/globalSearch", {
                searchTerm: param,
                filterModel: {},
              })
            }
            onSelect={selectSearchOptionHandler}
          />
        </div>
      </div>
      <div className="motif-row" style={{ paddingBottom: 25 }}>
        <div className="motif-col-xs-4" style={{ paddingBottom: 15 }}>
          <hr />
          <div className="motif-h5">Dropdown</div>
        </div>
        <div className="motif-col-xs-4">
          <SFDropdown
            id={"avatar-dropdown"}
            open={false}
            items={[
              {
                label: "Item 1",
                onClick: () => alert("Click"),
              },
              {
                label: "Item 2",
                onClick: () => alert("Click"),
              },
              {
                label: "Item 3",
                onClick: () => alert("Click"),
              },
            ]}
          ></SFDropdown>
        </div>
      </div>
      {/* Tabs */}
      <div className="motif-row" style={{ paddingBottom: 25 }}>
        <div className="motif-col-xs-4" style={{ paddingBottom: 15 }}>
          <hr />
          <div className="motif-h5">Tab bar</div>
        </div>
        <div className="motif-col-xs-4">
          <SFTabs value={activeTab} onChange={onClickTabHandler}>
            <SFTab value={0} label={"Tab 1"}></SFTab>
            <SFTab value={1} label={"Tab 2"}></SFTab>
            <SFTab value={2} label={"Tab 3"}></SFTab>
          </SFTabs>
          <div hidden={activeTab !== 0}>Content 1</div>
          <div hidden={activeTab !== 1}>Content 2</div>
          <div hidden={activeTab !== 2}>Content 3</div>
        </div>
      </div>
      <div className="motif-row motif-no-gutter" style={{ paddingBottom: 25 }}>
        <div className="motif-col-xs-4" style={{ paddingBottom: 15 }}>
          <hr />
          <div className="motif-h5">Buttons</div>
        </div>
        <div className="motif-col-lg-2">
          <SFButton>Primary Button</SFButton>
        </div>
        <div className="motif-col-lg-2">
          <SFButton variant="secondary">Secondary Button</SFButton>
        </div>
        <div className="motif-col-lg-2">
          <SFButton>
            <SFAddIcon className="sm-icon" style={{ marginRight: 1 }} /> Button
            with icon
          </SFButton>
        </div>
        <div className="motif-col-lg-2">
          <SFButton variant="text-link-secondary">Text button</SFButton>
        </div>
        <div className="motif-col-lg-2">
          <SFButton disabled={true}>Disabled button</SFButton>
        </div>
        <div className="motif-col-lg-2">
          <SFButton variant="text-link" disabled={true}>
            Disabled text button
          </SFButton>
        </div>
      </div>

      <SFGridContainer>
        <SFGridItem xs={12}>
          <hr />
          <div>Badges</div>
        </SFGridItem>
        <SFGridItem xs={12}>
          <SFStack direction="row" spacing={4}>
            <SFBadge badgeContent={1} color="primary">
              <SFDashboardIcon />
            </SFBadge>
            <SFBadge badgeContent={2} color="secondary">
              <SFDashboardIcon />
            </SFBadge>
            <SFBadge
              badgeContent={3}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <SFDashboardIcon />
            </SFBadge>
            <SFBadge badgeContent={4} variant="dot">
              <SFDashboardIcon />
            </SFBadge>
            <SFBadge
              badgeContent={100}
              max={99}
              variant="standard"
              hasIcon={true}
              icon={<SFDashboardIcon />}
            >
              <SFDashboardIcon />
            </SFBadge>
          </SFStack>
        </SFGridItem>
      </SFGridContainer>

      <div className="motif-row" style={{ paddingBottom: 25 }}>
        <div className="motif-col-xs-4" style={{ paddingBottom: 15 }}>
          <hr />
          <div className="motif-h5">Toasts</div>
        </div>
        <div className="motif-col-lg-2">
          <SFButton
            onClick={() => {
              dispatch(
                toastActions.showErrorMessage("This is an error toast!")
              );
            }}
          >
            Click to show error toast
          </SFButton>
        </div>
        <div className="motif-col-lg-2">
          <SFButton
            onClick={() => {
              dispatch(toastActions.showInfoMessage("This is an info toast!"));
            }}
          >
            Click to show info toast
          </SFButton>
        </div>
        <div className="motif-col-lg-2">
          <SFButton
            onClick={() => {
              dispatch(
                toastActions.showWarningMessage("This is a warning toast!")
              );
            }}
          >
            Click to show warning toast
          </SFButton>
        </div>
        <div className="motif-col-lg-2">
          <SFButton
            onClick={() => {
              dispatch(
                toastActions.showSuccessMessage("This is a success toast!")
              );
            }}
          >
            Click to show success toast
          </SFButton>
        </div>
      </div>
      <SFTabbedCard>
        <SFCardTab title="Insights">
          <Insights></Insights>
        </SFCardTab>
        <SFCardTab title="Proficiency Level">
          <ProficiencyLevel></ProficiencyLevel>
        </SFCardTab>
      </SFTabbedCard>
      <div className="motif-row motif-no-gutter">
        <div className="motif-col-lg-2">
          <SFCard>
            <div style={{ width: 100, height: 100 }} />
          </SFCard>
        </div>
        <div className="motif-col-lg-2">
          <SFCard>{cardHeader}</SFCard>
        </div>
        <div className="motif-col-lg-2">
          <SFCard>
            {cardHeader}
            {cardBody}
          </SFCard>
        </div>
        <div className="motif-col-lg-2">
          <SFCard>
            {cardImageSection}
            {cardHeader}
            {cardBody}
          </SFCard>
        </div>
      </div>
      <div className="motif-col-lg-12">
        <GridExample></GridExample>
      </div>

      <div className="motif-row motif-no-gutter">
        <div className="motif-col-lg-12">
          <SFCard>
            <div>
              <SFLineChart
                data={lineChartData}
                lines={lineChartLines}
                dataKey="name"
              />
            </div>
          </SFCard>
        </div>
      </div>

      <div className="motif-col-lg-12">
        <p>Accordion Group</p>
        <SFAccordion
          expanded={accordionOpen === "panel1"}
          onChange={accordionChangeHandler("panel1")}
        >
          <SFAccordionSummary>
            <Typography variant="h4" component="div">
              Accordion Title 1
            </Typography>
          </SFAccordionSummary>
          <SFAccordionDetails>Content 1</SFAccordionDetails>
        </SFAccordion>
        <SFAccordion
          expanded={accordionOpen === "panel2"}
          onChange={accordionChangeHandler("panel2")}
        >
          <SFAccordionSummary>
            <Typography variant="h4" component="div">
              Accordion Title 2
            </Typography>
          </SFAccordionSummary>
          <SFAccordionDetails>Content 2</SFAccordionDetails>
        </SFAccordion>
        <p>Accordion</p>

        <SFAccordion>
          <SFAccordionSummary>
            <Typography variant="h4" component="div">
              Accordion Title
            </Typography>
          </SFAccordionSummary>
          <SFAccordionDetails>Content</SFAccordionDetails>
        </SFAccordion>
      </div>
      <div className="motif-row" style={{ paddingBottom: 25 }}>
        <div className="motif-col-xs-4" style={{ paddingBottom: 15 }}>
          <hr />
          <div className="motif-h5">Skeleton</div>
        </div>
        <div className="motif-col-xs-2">
          <span>Default body rows(6)</span>
          <SFSkeleton />
        </div>
        <div className="motif-col-xs-2">
          <span>12 body rows</span>
          <SFSkeleton rows={12} />
        </div>
      </div>
      <SFGridContainer>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5" sx={{ my: 2 }}>
            Sort button group
          </Typography>
          <SortButtonGroup />
        </SFGridItem>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5" sx={{ my: 2 }}>
            Button group
          </Typography>
          <ButtonGroup />
        </SFGridItem>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5" sx={{ my: 2 }}>
            Include CheckBox
          </Typography>
          <SFStack direction="row" spacing={1}>
            <IncludeCheckbox />
          </SFStack>
        </SFGridItem>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5">CheckBox</Typography>
          <SFStack direction="row" spacing={1}>
            <SFCheckbox label="Default checkbox" />
            <SFCheckbox
              id="disabled-checkbox"
              disabled
              label="Disabled checkbox"
            />
          </SFStack>
        </SFGridItem>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5" sx={{ my: 2 }}>
            Radio group
          </Typography>
          <RadioGroupExample />
        </SFGridItem>
      </SFGridContainer>
      <SFGridContainer>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5" sx={{ my: 2 }}>
            Accordion card
          </Typography>
          <SFAccordionCard title="Accordion card title">
            Accordion card content
          </SFAccordionCard>
        </SFGridItem>
        <SFGridItem xs={12}>
          <SFDivider />
          <Typography variant="h5" sx={{ my: 2 }}>
            Stepper
          </Typography>
          <Stepper />
        </SFGridItem>
      </SFGridContainer>
    </SFContainer>
  );
};

export default Mock;
